import { CommentingContentProvider } from './commenting/CommentingContentProvider';
import { IUserNotificationContentProvider } from './INotificationProvider';
import { UserNotificationType } from './UserNotificationType';
import { UserNotificationActions } from '../redux/UserNotificationActions';

export function NotificationProviders(userNotificationActions: UserNotificationActions): _.Dictionary<IUserNotificationContentProvider> {
    // this is used to register feature content providers
    return {
        [UserNotificationType.Commenting]: new CommentingContentProvider(userNotificationActions)
    };
}
